export default "__VITE_PUBLIC_ASSET__3792bbe2__"